import { useEffect, useState } from 'react'
import { Link as RouterLink, NavLink } from 'react-router-dom'
import { AppBar, Button, ButtonGroup, Box, Grid, Toolbar, IconButton, Typography, Drawer } from '@mui/material'
import Link from '@mui/material/Link'
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil'
import MenuIcon from '@mui/icons-material/Menu'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { api_menu_list } from '../states/selector'
import { CONFIG } from '../states/settings'



// NOTE:
// recoilstateで文字サイズを引き回そうとしたが
// 更新後に再レンダリングするためやむを得ずグローバル変数に
let gl_font_size = 100

const AppBarHead = () => {
  let [ isOpenDrawer, setDrawerState ] = useState(false)
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)

  useEffect(()=>{
    setMenuList(menu_list)
  }, [])

  // デフォルトの文字サイズ（標準=100%）を設定
  useEffect(()=>{
    // ページロード時に標準サイズ（100%）を適用
    if (!document.querySelector('html').style.fontSize) {
      gl_font_size = 100
      document.querySelector('html').style.fontSize = '100%'
    }
  }, [])

  let Logo = ()=>{
    return (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: { xs: 1, sm: 2 },
        rowGap: { xs: 0.25, sm: 2 },
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        maxWidth: '100%',
        overflow: 'hidden',
      }}>
        <Typography 
          variant="h5" 
          color="inherit" 
          component="p" 
          className='logo_head'
          sx={{
            flexShrink: 0,
            '& img': {
              maxWidth: { xs: '90px', sm: '120px' },
              height: 'auto',
            }
          }}
        >
          <a href='https://www.town.kamigori.hyogo.jp/index.html'><img src={`${CONFIG.SITE_ROOT_PATH}/logo.jpg`} alt='上郡町' /></a>
        </Typography>
        <Typography 
          variant="h6" 
          color="inherit" 
          component="p" 
          sx={{ 
            fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem', lg: '1.1rem' }, 
            lineHeight: { xs: 1.2, sm: 1.4 },
            whiteSpace: { xs: 'normal', sm: 'nowrap' },
            wordBreak: { xs: 'break-word', sm: 'normal' },
            overflow: 'hidden',
            flex: { xs: '1 1 100%', sm: '0 1 auto' },
            maxWidth: '100%',
          }}
        >
        防災かみごおり配信情報一覧
        </Typography>
      </Box>
    )
  }

  let FontChange = ()=>{
    let change_font_size = (()=>{

      return (e)=>{
        let plus = e.currentTarget.value >> 0
        let fsize_to = ( plus == 0 ) ? 100 : (gl_font_size + plus)
        gl_font_size = fsize_to

        let fsize = fsize_to + '%'
        document.querySelector('html').style.fontSize = fsize
      }
    })();

    return (
      <Box sx={{ textAlign:'center' }} mt='25px'>
        <Typography sx={{ textAlign:'center', fontSize:'16px', padding:'5px 0'}} color="inherit" component="p">
          文字サイズ変更
        </Typography>
        <ButtonGroup variant='contained'>
          <Button sx={{ fontSize:'18px' }} color='info'      value='-5' onClick={change_font_size}>縮小</Button>
          <Button sx={{ fontSize:'18px' }} color='secondary' value='0'  onClick={change_font_size}>標準</Button>
          <Button sx={{ fontSize:'18px' }} color='info'      value='5'  onClick={change_font_size}>拡大</Button>
        </ButtonGroup>
      </Box>
    )
  }

  let SearchBox = ()=>{
    return(
      <Box mt='10px' sx={{ padding:'20px' }}>
        <Link underline='none' component={RouterLink} to={`${CONFIG.PAGE_ROOT_PATH}/search`} onClick={()=>{ setDrawerState(false) }}>
          <SearchRoundedIcon sx={{ fontSize:'36px', verticalAlign:'middle' }}/>
          <Button
            sx={{
              color:'#263238',
              fontSize:'18px',
            }}>サイト内検索</Button>
        </Link >
      </Box>
    )
  }

  let GoTop = ()=>{
    return(
      <Typography variant="h6" color="inherit" ml='50px' component="p">
        <a href={`${CONFIG.PAGE_ROOT_PATH}/`}>TOP</a>
      </Typography>
    )
  }

  let GlobalMenu = ()=>{
    
    return (
      <Box sx={{ textAlign:'right' }}>
        <MenuIcon  fontSize='large' onClick={ ()=>setDrawerState(true) }/>

        <Drawer
          anchor='right'
          open={ isOpenDrawer }
          onClose={()=>setDrawerState(false)}
          className='staff-drawer'
        >
          <Link underline='none' variant="h3" component={RouterLink} to={`${CONFIG.PAGE_ROOT_PATH}/`} onClick={()=>{ setDrawerState(false) }}>
            <Button
              fullWidth={true}
              sx={{
                minWidth: '250px',
                color:'#263238',
                // fontSize:'1.25rem',
                fontSize:'22px',
                display:'block',
                textAlign:'left',
                padding:'10px 20px',
              }}>Top</Button>
          </Link>
          {
            menu_list.map((v, index)=>{
              return(
                <Link key={v.group_name || index} sx={{ borderTop:1, borderColor:'grey.200' }} underline='none' variant="h3" component={RouterLink} to={`${CONFIG.PAGE_ROOT_PATH}/${v.group_name}`} onClick={()=>{ setDrawerState(false) }}>
                  <Button
                    className="drawer-menu-group-name"
                    fullWidth={true}
                    sx={{
                      color:'#263238',
                      //fontSize:'1.25rem',
                      fontSize:'22px',
                      display:'block',
                      textAlign:'left',
                      padding:'10px 20px',
                    }}>{v.group_name}</Button>
                </Link>
              )
            })
          }
          <Box sx={{ borderTop:1, borderBottom:1, borderColor:'grey.200' }} >
            <Button
              fullWidth={true}
              onClick={()=>setDrawerState(false)}
              sx={{
                color:'#263238',
                //fontSize:'1.25rem',
                fontSize:'22px',
                display:'block',
                textAlign:'left',
                padding:'10px 20px',
              }}><DisabledByDefaultIcon fontSize='small' sx={{ fontSize:'25px', marginBottom:'2.75px',verticalAlign:'middle'}}/> close</Button>
            
          </Box>

          <FontChange />
          <SearchBox />
        </Drawer>

      </Box>
    )
  }

  let MenuList = ()=>{
    return (
      menu_list.map((v, index)=>{
        return (
          <Typography key={v.group_name || index} ml='20px' variant="h6" color="inherit" component="p">
            {/* <NavLink */}
            {/*   activeStyle={{ */}
            {/*     fontWeight: 'bold', */}
            {/*     color: 'yellow' */}
            {/*   }} */}
            {/*   to={`/${v.group_name}`} onClick={onclick}> */}
            {/*   {v.group_name} */}
            {/* </NavLink> */}

            <a href={`/${v.group_name}`}>{v.group_name}</a>
          </Typography>
        )
      })
    )
  }

// こいつを更新しないとフィードが変わらないと予想
//setSelectedMenu

  return (
    <AppBar position="sticky" color='inherit' sx={{ zIndex: 1200, overflowX: 'hidden' }}>
      <Toolbar 
        variant="dense" 
        className='Menu-head'
        sx={{
          paddingX: { xs: 1, sm: 2 },
          paddingY: { xs: 1.25, sm: 1 },
          overflowX: 'hidden',
          minHeight: { xs: '68px', sm: '64px' },
        }}
      >
        <Grid 
          container 
          justifyContent='space-between' 
          alignItems='center' 
          flexWrap='nowrap'
          sx={{
            width: '100%',
            maxWidth: '100%',
            margin: 0,
          }}
        >
          <Grid 
            item 
            xs 
            sm={6} 
            md={6} 
            lg={6} 
            xl={6}
            sx={{
              minWidth: 0,
              maxWidth: { xs: 'calc(100% - 48px)', sm: '50%' },
              overflow: 'hidden',
              paddingRight: { xs: 0.5, sm: 1 },
            }}
          >
            <Logo />
          </Grid>
            {/* <GoTop /> */}
          <Grid 
            item 
            xs="auto"
            sm={6} 
            md={6} 
            lg={6} 
            xl={6}
            sx={{
              flexShrink: 0,
            }}
          >
            <GlobalMenu />
          </Grid>
            {/* <MenuList /> */}
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default AppBarHead
